import React, {useState} from 'react'
import {Stack, TextField, Typography} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import {colors} from '@/constants'
import HoverButton from '@/components/UI/button/HoverButton'
import TransCustom from '@/components/UI/i18next'
import {useTranslation} from 'react-i18next'
import {errorCodeHandler} from '@/helpers/localErrorCodeHandler'
import {isErrorResponse} from '@/helpers/IsErrorResponse'
import SupportService from '@/services/api/Support'
import {inputSx, MESSAGE_MAX, SUBJECT_MAX} from './constants'

interface Props {
  onCreated: () => void
  onCancel: () => void
}

const NewTicketForm = ({onCreated, onCancel}: Props) => {
  const {t} = useTranslation()
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)

  const canSend = subject.trim().length > 0 && message.trim().length > 0

  const submit = async () => {
    if (!canSend || busy) return
    setBusy(true)
    try {
      const response = await SupportService.createTicket({
        subject: subject.trim(),
        message: message.trim(),
      })
      if (isErrorResponse(response.data)) {
        errorCodeHandler(response.data)
        return
      }
      onCreated()
    } catch (e) {
      errorCodeHandler(e)
    } finally {
      setBusy(false)
    }
  }

  return (
    <Stack flex="auto" minHeight={0} gap="18px" marginTop="20px">
      <Stack
        direction="row"
        alignItems="center"
        gap="8px"
        className="pointer"
        width="max-content"
        onClick={onCancel}>
        <ArrowBackIcon style={{color: colors.gray, fontSize: '18px'}} />
        <TransCustom i18nKey="1741" color={colors.gray} fontSize="14px" />
      </Stack>

      <Stack gap="8px">
        <TransCustom i18nKey="1737" color={colors.lightBrown} fontSize="14px" />
        <TextField
          value={subject}
          onChange={(e) => setSubject(e.target.value.slice(0, SUBJECT_MAX))}
          size="small"
          fullWidth
          sx={inputSx}
        />
      </Stack>

      <Stack gap="8px" flex="auto" minHeight={0}>
        <TransCustom i18nKey="1738" color={colors.lightBrown} fontSize="14px" />
        <TextField
          value={message}
          onChange={(e) => setMessage(e.target.value.slice(0, MESSAGE_MAX))}
          multiline
          minRows={6}
          maxRows={12}
          fullWidth
          sx={inputSx}
        />
        <Typography color={colors.gray} fontSize="12px" textAlign="right">
          {message.length} / {MESSAGE_MAX}
        </Typography>
      </Stack>

      <Stack direction="row" gap="14px" justifyContent="flex-end">
        <HoverButton
          onClick={onCancel}
          fontSize="15px"
          fontWeight="400"
          height="42px"
          padding="10px 24px"
          background={colors.brown}>
          {t('1749')}
        </HoverButton>
        <HoverButton
          onClick={submit}
          disabled={!canSend || busy}
          fontSize="15px"
          fontWeight="400"
          height="42px"
          padding="10px 24px"
          textColor={colors.brown}
          background={colors.yellow}>
          {t('1739')}
        </HoverButton>
      </Stack>
    </Stack>
  )
}

export default NewTicketForm
